import type { Tone } from "@wmart/ui";
import type { SupplierOrderStatus } from "@wmart/shared-types";

/**
 * Supplier-facing status-tone map. Mirrors the admin `orderStatusTone`
 * vocabulary (info = action needed, olive = in-flight, success = done,
 * neutral = closed, danger = cancelled) but over the PO lifecycle:
 *   new          → info    (needs the supplier's attention — acknowledge)
 *   acknowledged → olive   (in progress)
 *   preparing    → olive   (in progress)
 *   ready        → success (the supplier's part is done)
 *   cancelled    → danger
 *   closed       → neutral (received by WMart — terminal)
 */
export const PO_STATUS_TONE: Record<SupplierOrderStatus, Tone> = {
  new: "info",
  acknowledged: "olive",
  preparing: "olive",
  ready: "success",
  shipped: "info",
  received: "success",
  cancelled: "danger",
  closed: "neutral",
};

/**
 * Human label per status — suppliers never see the raw enum text. (Today the
 * enum values happen to read fine, but the indirection keeps copy decisions
 * out of the wire format.)
 */
export const PO_STATUS_LABEL: Record<SupplierOrderStatus, string> = {
  new: "New",
  acknowledged: "Acknowledged",
  preparing: "Preparing",
  ready: "Ready",
  shipped: "Shipped",
  received: "Received",
  cancelled: "Cancelled",
  closed: "Closed",
};
